import React, { useState, useEffect, useRef } from 'react'

import { Button, Dialog, Grid, Icon, Typography, Select, FormHelperText, Switch, Tooltip } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import RichTextEditor from 'react-rte';
import DialogLoader from '../../../../components/Loader/DialogLoader';

import { InputBaseField, SelectField, TextareaField } from '../../../../components/InputField/InputField';
import { Label, DraggableComponent } from '../../../../components/UiElements/UiElements'
import { PostDataAPI } from '../../../../Services/APIService';
import { withSnackbar } from "../../../../components/Message/Alert";
import useStyles from "./styles";
import { validateEmail, handleNumberKeyPress, isDigitsOnly, formateMdnNumber, allowedAttachmentsForEmail } from '../../../../../src/components/Common/Extensions';
import axios from 'axios';
import moment from 'moment';
import { ActionDialog } from "../../../../components/ActionDialog/ActionDialog";


function AddNewAddress({ dialogOpenClose, handleClose, handleSuccessClose, objEventData, ...props }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
     const commonAttachments = allowedAttachmentsForEmail();
    //const startDate = moment(new Date(objEventData.startDate.setHours(9)).setMinutes(0));
    //const endDate = moment(new Date(objEventData.endDate.setHours(9)).setMinutes(30));
    const [distributionList, setDistributionList] = useState([]);
    const [defaultTemplate, setDefaultTemplate] = useState("Select Distribution");
    const [isDisabled, setIsDisabled] = useState(false);
    const [state, setState] = useState(objEventData);

    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const [errorMessages, setErrorMessages] = useState({
        errorNote: false,
        errorEditorMaxValue: false,
    })
    const [mediaList, setMediaList] = useState([]);
    const addMediaFile = useRef(null);

    const { showMessage } = props;

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }


    const removeMedia = (i) => {
        const updatedMediaFileList = mediaList.filter((item, index) => index !== i);
        setMediaList(updatedMediaFileList);

        setState((prevState) => {
            return { ...prevState, addMedia: "" };
        });
    };

    function uploadSingleFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const isDocAlreadyExists = mediaList.filter(
            (item) => item.fileName == e.target.files[0].name
        );

        if (isDocAlreadyExists && isDocAlreadyExists.length > 0) {
            showMessage("Error", "File/Document already selected.", "error", 3000);
            return
        }

        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg .csv .xlsx .pdf .docx", "error", 3000);
                return;
        }
        addMedia(e.target.files);
    }
    const addMedia = (file) => {
        debugger;
        if (file == null || file.length <= 0) {
            return
        }
        const name = file[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);

        let selectedFile = addMediaFile.current.files[0];
        var selectedFileSize = (selectedFile.size / 1024);
        const previousFileSize = mediaList.reduce((total, item) => total + item.fileSize, 0);

        if ((selectedFileSize + previousFileSize) >= 10000) {
            alert("File Size Exceeds 10 MB");
            return
        }
        setMediaList((prevList) => [...prevList, { file: selectedFile, fileToSend: selectedFile, fileName: selectedFile.name, extension: ext, fileSize: selectedFileSize }]);

        state.addMedia = '';
    }
    const handleDateTimeChange = (value, dateString, name) => {
        debugger;
        //const { name, value } = e.target;
        //if (value && name == 'endDate' && state.startDate && state.startDate > value) {
        //    showMessage("Error", "Event end date can not be earlier than event Start date.", "error");
        //    return;
        //}
        //if (value && name == 'startDate' && state.endDate && state.endDate < value) {
        //    showMessage("Error", "Event Start date can not be later than event End date.", "error");
        //    return;
        //}
        if (state.allDay) {
            var dateValue = new Date(value);
            if (name == 'startDate') {
                var startDate = moment(new Date(dateValue.setHours(0)).setMinutes(0));
                var endDate = moment(new Date(dateValue.setHours(23)).setMinutes(59));
                setState(prevState => ({
                    ...prevState,
                    [name]: startDate,
                    endDate: endDate
                }));
            }
            else {
                //var startDate = moment(new Date(value.setHours(0)).setMinutes(0));
                var endDate = moment(new Date(dateValue.setHours(23)).setMinutes(59));
                setState(prevState => ({
                    ...prevState,
                    [name]: endDate,
                }));
            }

        } else {
            setState(prevState => ({
                ...prevState,
                [name]: moment(new Date(value))
            }));
        }
    }

    const removeSpacesFromKeys = (obj) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
            const newKey = key.replace(/\s/g, '_');
            newObj[newKey] = obj[key];
        });
        return newObj;
    };


    const Validate = (errorList) => {
        if (!state.eventName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEventName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEventName: false
            }));
        }

        if (!state.distributionListId) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDistributionListId: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorDistributionListId: false
            }));
        }

        if (!state.startDate) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorStartDate: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorStartDate: false
            }));
        }

        if (!state.endDate) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEndDate: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEndDate: false
            }));
        }
        if (state.startDate && state.endDate && state.startDate > state.endDate) {
            showMessage("Error", "Event end date can not be earlier than event Start date.", "error");
            errorList.push(true);
        }
    }

    const cancelEvent = () => {
        showActionDialog("Are you sure you want to cancel this event?", "confirm", function () {
            setIsLoading(true);
            var method = "fdnevents/delete";

            PostDataAPI(method, state, true).then((result) => {
                if (result.success) {
                    if (result.data) {
                        setIsLoading(false);
                        handleSuccessClose("Event canceled successfully.");

                    }
                    else {
                        showMessage("Error", "Error canceling event, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
                setIsLoading(false);

            })
        });
    }

    const addEvent = () => {
        let errorList = [];
        //state.startDate = newEventDate;
        //state.endDate = newEventDate;
        Validate(errorList);
        if (errorList.length < 1) {
            setIsLoading(true)
            var method = "fdnevents/add";
            if (state.eventId && state.eventId > 0)
                method = "fdnevents/update";
            //state.startDate = moment(new Date(state.startDate).toISOString());
           // state.endDate = moment(new Date(state.endDate).toISOString());
            state.uTCStartDate = new Date(state.startDate).toUTCString();
            state.uTCEndDate = new Date(state.endDate).toUTCString();
            const formData = new FormData();
            for (var key in state) {
                if (state[key]
                    && key != "fileToSend"
                    && key != 'mediaFiles'
                    && key != 'mediaFileNames'
                    && key != 'startDate'
                    && key != 'endDate'
                    && key != "photoName"
                    && key != "encUserID"
                )
                    formData.append(key, state[key]);
            }
      
            for (const element of mediaList) {
                if (!element.mediaId) {
                    formData.append("mediaFiles", element.fileToSend);
                } else {
                    formData.append("attachedFileIds", element.mediaId);
                }
            }
            PostDataAPI(method, formData, true, "formData").then((result) => {
                setIsLoading(false)
                if (result.success && result.data) {
                    var message = "Event added successfully";
                    if (state.eventId && state.eventId > 0)
                        message = "Event updated successfully";
                    handleSuccessClose(message);
                    //if (result.data) {
                    //if (state.addressBookId > 0)
                    //    handleSuccessClose("Address updated successfully.");
                    //else
                    //    handleSuccessClose("Address saved successfully.");
                    //}
                    //else {
                    //  showMessage("Error", "Error updating address, please contact administrator", "error", 3000);
                    //}
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);

            })
        }

    }
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        //if (checked) {
        //    showActionDialog("Please confirm to create overnight shipping label. Additional charges will apply.", "confirm", function () {
        //        setState(prevState => ({
        //            ...prevState,
        //            [name]: checked
        //        }));
        //    });
        //} else {
        var startDate = new Date(state.startDate);
        var endDate = new Date(state.endDate);
        if (checked) {
            startDate = moment(new Date(startDate.setHours(0)).setMinutes(0));
            endDate = moment(new Date(endDate.setHours(23)).setMinutes(59));
        }
        else {
            startDate = moment(new Date(startDate.setHours(9)).setMinutes(0));
            endDate = moment(new Date(endDate.setHours(9)).setMinutes(30));
        }

        setState(prevState => ({
            ...prevState,
            [name]: checked,
            startDate: startDate,
            endDate: endDate
        }));
        //}

    };

    const loadDistributionList = () => {
        setIsLoading(true);
        //var params = { distributionType: 'event' }
        var params = { category: 'PR' }
        PostDataAPI("fdndistributionlist/getDistributionList", params).then((result) => {

            if (result.success && result.data) {
                // Define your default value
                const defaultValue = {
                    listId: 0,  // Set a unique value for the default item
                    listName: 'Select Invitation list', // Label for the default item
                };
                // Concatenate the default value with result.data
                const dataWithDefault = [defaultValue, ...result.data];

                // Transform the data
                const transformedData = dataWithDefault.map((item) => ({
                    value: item.listId,
                    label: item.listName,
                }));
                setDistributionList(transformedData);
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    };

    useEffect(() => {
        loadDistributionList();
        var startDate = new Date(state.startDate);
        var endDate = new Date(state.endDate);
        if (startDate.getHours() == 12 && startDate.getMinutes() == 0 && endDate.getHours() == 11 && endDate.getMinutes() == 59) {
            setState(prevState => ({
                ...prevState,
                allDay: true
            }));
        }
        console.log(objEventData)
        if (objEventData && objEventData.eventId > 0) {
            setIsDisabled(objEventData.endDate < new Date() ? true : false);
            if (objEventData.attachmentFiles != null) {
                setMediaList(objEventData.attachmentFiles);
            }
        }
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            PaperComponent={DraggableComponent}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="sm"
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>{state.eventId && state.eventId > 0 ? "Edit Event" : "Add New Event"}</Typography>

                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>


                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <Scrollbars autoHeight autoHeightMax={500}>
                        <div className={classes.content}>
                            <Grid container spacing={2}>
                                <Grid item sm={12} md={6} lg={6} xl={6} >
                                    <Label size={12} title="Event Name" mandatory={true} />
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <InputBaseField
                                            id="eventName"
                                            name="eventName"
                                            type="text"
                                            value={state?.eventName}
                                            onChange={handleChange}
                                            placeholder='Event Name'
                                            IsDisabled={isDisabled}
                                            MaxLength={80}
                                        />
                                        {errorMessages.errorEventName && !state.eventName ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter event name
                                        </FormHelperText>) : ('')}
                                    </Grid>
                                </Grid>
                                <Grid item sm={12} md={6} lg={6} xl={6} >
                                    <Label size={12} title="Location" />
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <InputBaseField
                                            id="location"
                                            name="location"
                                            type="text"
                                            value={state?.location}
                                            onChange={handleChange}
                                            placeholder='Event Location'
                                            IsDisabled={isDisabled}
                                            MaxLength={500}
                                        />
                                        {/*{errorMessages.errorLastName && !state.lastName ? (<FormHelperText style={{ color: "red" }} >*/}
                                        {/*    Please enter last name*/}
                                        {/*</FormHelperText>) : ('')}*/}
                                    </Grid>

                                </Grid>
                                <Grid item sm={6} md={6} lg={6} xl={6}>
                                    <Grid row>
                                        <Label
                                            title="Event Invitation List"
                                            size={12}
                                            mandatory={true}
                                        />

                                        <SelectField
                                            options={distributionList}
                                            onChange={handleChange}
                                            value={state.distributionListId}
                                            name="distributionListId"
                                            placeholder={"Select Distribution List"}
                                            defaultValue={defaultTemplate}
                                            className={classes.selectBaseInput}
                                            IsDisabled={isDisabled}
                                        ></SelectField>
                                        {errorMessages.errorDistributionListId &&
                                            (!state.distributionListId ||
                                                state.distributionListId <= 0) ? (
                                            <FormHelperText style={{ color: "red" }}>
                                                Please select event invitation list
                                            </FormHelperText>
                                        ) : (
                                            ""
                                        )}
                                    </Grid>
                                </Grid>

                                <Grid container style={{ paddingTop: '15px' }}>
                                    <Grid item xl={6} md={6} sm={6} lg={6} className={classes.headform}>

                                    </Grid>
                                    <Grid item xl={6} md={6} sm={6} lg={6} style={{ textAlign: "right" }}>

                                    </Grid>
                                </Grid>
                                <Grid item sm={12} md={4} lg={4} xl={4} style={{ paddingTop: "0px" }}>
                                    <Label size={12} title="Start Date" />
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <InputBaseField
                                            id="startDate"
                                            name="startDate"
                                            type="datetime"
                                            value={state?.startDate}
                                            onChange={(value, dateString) => { handleDateTimeChange(value, dateString, 'startDate') }}
                                            placeholder='Event Start Date'
                                            IsDisabled={isDisabled}
                                            MaxLength={2000}
                                            dateFormat={"MM/DD/yyyy hh:mm A"}
                                            hideTime={state?.allDay}
                                        //onOk={(value, dateString) => { handleDateTimeChange(value, dateString, 'startDate') }}
                                        />
                                        {errorMessages.errorStartDate && !state.startDate ? (<FormHelperText style={{ color: "red" }} >
                                            Please select event start date
                                        </FormHelperText>) : ('')}
                                    </Grid>
                                </Grid>
                                <Grid item sm={12} md={4} lg={4} xl={4} style={{ paddingTop: "0px" }}>
                                    <Label size={12} title="End Date" />
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <InputBaseField
                                            id="endDate"
                                            name="endDate"
                                            type="datetime"
                                            value={state?.endDate}
                                            onChange={(value, dateString) => { handleDateTimeChange(value, dateString, 'endDate') }}
                                            placeholder='Event End Date'
                                            IsDisabled={isDisabled}
                                            MaxLength={2000}
                                            dateFormat={"MM/DD/yyyy hh:mm A"}
                                            hideTime={state?.allDay}
                                        //onOk={(value, dateString) => { handleDateTimeChange(value, dateString, 'startDate') }}
                                        />
                                        {errorMessages.errorEndDate && !state.endDate ? (<FormHelperText style={{ color: "red" }} >
                                            Please select event end date
                                        </FormHelperText>) : ('')}
                                    </Grid>
                                </Grid>
                                <Grid item sm={12} md={4} lg={4} xl={4} style={{ textAlign: 'center', alignSelf: 'end' }}>
                                    <span style={{ fontSize: "14px", fontWeight: "500", color: "#4b4b4b" }}>All Day</span>
                                    <Switch
                                        name="allDay"
                                        checked={state?.allDay}
                                        onChange={handleCheckboxChange}
                                        color="primary"
                                        disabled={isDisabled}
                                    />
                                </Grid>
                                <Grid item sm={12} md={12} lg={12} xl={12} >
                                    <Label size={12} title="Description" />
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <TextareaField
                                            id="eventDescription"
                                            name="eventDescription"
                                            rows={6}
                                            placeholder="Event Description"
                                            MaxLength="2000"
                                            value={state.eventDescription}
                                            onChange={handleChange}
                                            Disabled={isDisabled}></TextareaField>
                                    </Grid>

                                </Grid>

                                
                                <Grid item sm={12} md={12} lg={12} xl={12}>
                                    <Grid row>

                                        <Grid item sm={12} md={12} lg={12} xl={12}>
                                            <Grid row>
                                                <Grid container spacing={1}>
                                                    <Grid item sm={9} md={9} lg={9} xl={9}>
                                                        <Grid row >
                                                            <Label title="Add Media" size={12} />
                                                            <Grid row className={classes.mediaInput}>
                                                                <input type="file" ref={addMediaFile} name="addMedia" value={state.addMedia} className={classes.inputFile}
                                                                    onChange={uploadSingleFile}
                                                                    placeholder="Add Media"></input>
                                                                {errorMessages.errorAddMediaDuplicate ? (<FormHelperText style={{ color: "red" }} >
                                                                    A file with the same name already exists.
                                                                </FormHelperText>) : ('')}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                            <Grid row>
                                                <Grid container spacing={1}>
                                                    <div className={classes.tabList}>
                                                        {mediaList
                                                            ? mediaList.map((item, i) => {
                                                                return (
                                                                    <div className={classes.tabs}>
                                                                        <button
                                                                            key={i}
                                                                            onClick={() => removeMedia(i)}
                                                                        >
                                                                            <CloseIcon className={'iconStyle'} />
                                                                        </button>

                                                                        <Tooltip title={item.fileName ? item.fileName : ""} placement="top">
                                                                            <div className={"tabText"}>
                                                                                {item.fileName ? item.fileName : ""}
                                                                            </div>
                                                                        </Tooltip>

                                                                    </div>
                                                                );
                                                            })
                                                            : ""}
                                                    </div>
                                                </Grid>
                                            </Grid>

                                        </Grid>

                                    </Grid>
                                </Grid>

                            </Grid>

                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            {state.eventId && state.eventId > 0 ? <Button className={isDisabled ? classes.deleteDisabledBtn:classes.deleteBtn} disabled={isDisabled} onClick={cancelEvent}>Cancel Event</Button> : ''}
                            <Button className={isDisabled ? classes.changeDisabledBtn : classes.changeBtn} disabled={isDisabled} onClick={addEvent}>{state.eventId && state.eventId > 0 ? "Edit Event" : "Add Event"}</Button>

                        </div>
                    </div>
                </div>
            </div>
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />
        </Dialog >
    )
}

export default withSnackbar(AddNewAddress);
